'use strict';

var moment = require('moment');
var _ = require('lodash');
var ChartDashboardPerformanceController = function ChartDashboardPerformanceController($scope, $rootScope, $filter, $state, momentService, userPreferencesService, analysisMetricService, chartDashboardPerformanceDataService, dataHandleService, chartDashboardTooltipFormattersService, transitionSearchCriteriaService, BrushSelectionFilter, dashboardCommonService, representationService) {
  var rmNumberFormat = $filter('rmNumberFormat');
  var momentConfig = momentService.FIELD.DASHBOARD_DATE;
  var months = moment.monthsShort(),
    monthsFull = moment.months(),
    curYear = dataHandleService.getYear();
  var now = momentService.now(momentConfig);
  $scope.curMonth = now.month();
  $scope.curFullYear = now.year();
  $scope.cogChannel = 'market-performance-chart';
  $scope.dataRepresentation = userPreferencesService.getUserSettingComponent('defaultPerformanceChart') || 'percentage';
  $scope.flightAnalysisTransitionErrorMessage = {
    visible: false
  };
  var analysisMetric = analysisMetricService.getAnalysisMetric($scope.screen);
  $scope.metrics = analysisMetric.getMetricValues($scope.mode);
  $scope.metricLabels = analysisMetric.getAvailableLabels($scope.mode);
  $scope.screenState.selectedMetric = _.find($scope.metricLabels, {
    id: userPreferencesService.getUserSettingComponent('defaultMarketMetric') || analysisMetric.getDefault()
  });
  $scope.onDataRepresentationChange = function (dataRepresentation) {
    if (dataRepresentation !== $scope.dataRepresentation) {
      $scope.dataRepresentation = dataRepresentation;
      $scope.reloadChart();
    }
  };
  $scope.chartFormatters = {
    xAxisTickFormatter: function xAxisTickFormatter(d, num) {
      return months[d] + ' \'' + (num <= d ? curYear : curYear + 1);
    },
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return rmNumberFormat(d, representationService.getYAxisFormat($scope.dataRepresentation));
    },
    tooltipFormatter: function tooltipFormatter(d) {
      var tooltipData = _.cloneDeep(d.metrics);
      tooltipData.tooltipTitle = monthsFull[d.month] + ' ' + (d.position <= d.month ? $scope.curFullYear : $scope.curFullYear + 1);
      return chartDashboardTooltipFormattersService.getTooltip({
        data: tooltipData,
        aggregationMode: $scope.screenState.aggregationMode,
        presentationMode: $scope.dataRepresentation,
        metric: $scope.screenState.selectedMetric.id
      });
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'dashboard-performance-chart-tooltip';
  var mapping = {
    percentage: {
      LY: dataHandleService.preparePercentageChartReferenceData,
      SEASONAL_AVG: dataHandleService.preparePercentageChartReferenceData,
      BUDGET: dataHandleService.preparePercentageChartBudgetData,
      TARGET: dataHandleService.preparePercentageChartTargetData
    },
    absolute: {
      LY: dataHandleService.prepareAbsoluteChartReferenceData,
      SEASONAL_AVG: dataHandleService.prepareAbsoluteChartReferenceData,
      BUDGET: dataHandleService.prepareAbsoluteChartBudgetData,
      TARGET: dataHandleService.prepareAbsoluteChartTargetData
    }
  };
  $scope.prepareChartData = function (data) {
    $scope.localMarkets = data.localMarkets;
    $scope.selectedDataToSummary = data.summary;
    return mapping[$scope.dataRepresentation][$scope.screenState.aggregationMode](data.monthData, $scope.screenState.selectedMetric.id);
  };
  function errorHandler() {
    $scope.prepareChartData({
      monthData: []
    });
    return [];
  }
  function flattenSelectedMonths() {
    return _.chain($scope.selectedMonths).flatten().map('month').value();
  }
  $scope.reloadChart = function () {
    chartDashboardPerformanceDataService.getData($scope.screenState.selectedMetric.id, $scope.screenState.aggregationMode, flattenSelectedMonths()).then($scope.prepareChartData, errorHandler).then($scope.renderChart).then($scope.updateChartSummary);
  };
  $scope.$watch('screenState.selectedCabins', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      var brushFilter = new BrushSelectionFilter('cabins', [newValue]);
      $scope.$emit('brush-filter:filterApplied', brushFilter);
    }
  });
  $scope.$watch('screenState.selectedMetric', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      $scope.metrics = analysisMetric.getMetricValues($scope.mode, $scope.screenState.selectedMetric.id);
      $scope.reloadChart();
    }
  });
  $scope.rangeChangeHandler = function () {
    $scope.selectedMonths = $scope.getBrushSelection();
    $scope.monthsLabel = dataHandleService.getLabelForSelectedMonths($scope.getBrushSelection());
    var brushFilter = new BrushSelectionFilter('year-and-month', flattenSelectedMonths());
    $scope.$emit('brush-filter:filterApplied', brushFilter);
  };
  $scope.contextMenuItems = [{
    caption: 'Market Analysis',
    event: 'context-menu:dashboard-market-performance:market-analysis'
  }, {
    caption: 'Flight Analysis',
    event: 'context-menu:dashboard-market-performance:flight-analysis'
  }];
  var AGGREGATION_MODE_MAPPING = {
    LY: 'lastYear',
    SEASONAL_AVG: 'seasonalAverage'
  };
  function mapAggregationMode(mode) {
    return AGGREGATION_MODE_MAPPING[mode] || AGGREGATION_MODE_MAPPING.LY;
  }
  function getScreenState() {
    return {
      dataDimension: $scope.screenState.dataDimension,
      selectedMetric: $scope.screenState.selectedMetric,
      selectedReference: mapAggregationMode($scope.screenState.aggregationMode),
      dataRepresentation: $scope.screenState.dataRepresentation
    };
  }
  function createTransitionObject(searchCriteria) {
    return {
      transitionData: {
        timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP),
        screenState: getScreenState(),
        searchCriteria: searchCriteria
      }
    };
  }
  $scope.navigateToMarketAnalysis = function () {
    var datesRanges = dataHandleService.getDatesRanges($scope.getBrushSelection(), $scope.curFullYear);
    var marketAndPosBrush = dashboardCommonService.getMarketsAndPosesBrush();
    var searchCriteria = transitionSearchCriteriaService.dashboardMarketPerformanceChartToMA(datesRanges, marketAndPosBrush.market, marketAndPosBrush.pos);
    $state.go('app.market-analysis', createTransitionObject(searchCriteria));
  };
  $scope.navigateToFlightAnalysis = function () {
    var marketAndPosBrush = dashboardCommonService.getMarketsAndPosesBrush();
    var transitionMarkets = _.intersection($scope.localMarkets, marketAndPosBrush.market);
    if (_.isEmpty(transitionMarkets)) {
      $scope.flightAnalysisTransitionErrorMessage.visible = true;
    } else {
      var datesRanges = dataHandleService.getDatesRanges($scope.getBrushSelection(), $scope.curFullYear);
      var searchCriteria = transitionSearchCriteriaService.dashboardMarketPerformanceChartToFA(datesRanges, transitionMarkets);
      $state.go('app.flight-analysis', createTransitionObject(searchCriteria));
    }
  };
  $scope.setDefaultSelectedMetric = function () {
    $scope.screenState.selectedMetric = _.find($scope.metricLabels, {
      id: userPreferencesService.getUserSettingComponent('defaultMarketMetric') || analysisMetric.getDefault()
    });
  };
};
ChartDashboardPerformanceController.$inject = ['$scope', '$rootScope', '$filter', '$state', 'MomentService', 'UserPreferencesService', 'AnalysisMetricService', 'ChartDashboardPerformanceDataService', 'ChartDashboardPerformanceService', 'ChartDashboardTooltipFormattersService', 'TransitionSearchCriteriaService', 'BrushSelectionFilterFactory', 'DashboardCommonService', 'DataRepresentationService'];
module.exports = ChartDashboardPerformanceController;